// Dynamic inline validation for all inputs and textarea
$('#security-package-form').on('input', 'input, textarea', function () {

    var name = $(this).attr('name');

    // Select error span
    var errorEl = $('.error-send-security-package-' + name);

    if (errorEl.length) {

        // Hide error visually
        errorEl.hide()
            .removeClass('in')
            .removeAttr('role'); // Remove alert role

        // Remove invalid aria state
        $(this).removeAttr('aria-invalid');

        // Remove aria-describedby if attached to this error
        if ($(this).attr('aria-describedby') === errorEl.attr('id')) {
            $(this).removeAttr('aria-describedby');
        }
    }
});


$('.send-security-package-btn').click(function (event) {
    event.preventDefault();

    var form = $(this).closest('form');

    // --- Reset previous accessibility states ---
    form.find('.alert-message')
        .hide()
        .removeClass('in')
        .removeAttr('role'); // Remove alert role to avoid double announcements

    form.find('input, textarea')
        .removeAttr('aria-invalid'); // Reset invalid state


    // --- Send AJAX request ---
    $.post(
        form.attr('action'),
        JSON.stringify({
            project: form.find('input[name=project]').val(),
            name: form.find('input[name=name]').val(),
            email: form.find('input[name=email]').val(),
            companyUrl: form.find('input[name=companyUrl]').val(),
            companyRole: form.find('input[name=companyRole]').val(),
            gRecaptchaResponse: form.find('textarea[name=gRecaptchaResponse]').val()
        }),
        'json'
    )
        .done(function(result) {

            // --- Reset form ---
            form[0].reset();

            // --- Announce success message ---
            $('#form-modal-success .modal__content')
                .attr('role', 'status') // SR-friendly success announcement
                .attr('aria-live', 'polite');

            // Close any active modal (Bootstrap behavior)
            $('.modal').click();

            // Show success modal
            setTimeout(function () {
                $('#form-modal-success').modal('show');
            }, 300);

            // Hide automatically after 5s
            setTimeout(function () {
                $('#form-modal-success').modal('hide');
            }, 5000);
        })
        .fail(function(xhr, status, error) {

            // --- Handle validation errors ---
            if (xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors.length) {

                var firstErrorField = null;

                $.each(xhr.responseJSON.errors, function(index, parseError) {
                    if (!parseError) return;

                    // Select error message element
                    var errorEl = form.find('.error-send-security-package-' + parseError.path);

                    // Inject error text and mark as alert for screen readers
                    errorEl.html(parseError.error)
                        .show()
                        .addClass('in')
                        .attr('role', 'alert'); // Screen readers read immediately

                    // Mark input as invalid (WCAG requirement)
                    var inputEl = form.find('[name="' + parseError.path + '"]');
                    inputEl.attr('aria-invalid', 'true');

                    // Connect input with its error message for comprehensive SR output
                    inputEl.attr('aria-describedby', errorEl.attr('id'));

                    // Save the first invalid field to set focus
                    if (!firstErrorField) {
                        firstErrorField = inputEl;
                    }
                });

                // --- Set focus on first field with error ---
                if (firstErrorField) {
                    firstErrorField.focus();
                }
            }
        });
});
